/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { ApplicationView } from '@gh/builder-shared-data';
import { Enum } from '@gh/core-data';

import { BuilderUserContext } from '../user';

@Directive({
  selector: '[ghAllowForView]',
})
export class AllowForViewDirective {
  private hasView = false;

  constructor(private viewContainerRef: ViewContainerRef,
              private templateRef: TemplateRef<Object>,
              private userContext: BuilderUserContext) {
  }

  @Input()
  set ghAllowForView(view: any) {
    if (typeof view === 'string') {
      view = Enum.byName(ApplicationView, <any>view);
    }

    if (this.userContext.applicationView === view && !this.hasView) {
      this.hasView = true;
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else if (this.userContext.applicationView !== view && this.hasView) {
      this.hasView = false;
      this.viewContainerRef.clear();
    }
  }
}
